import { H1 } from "@dune/ui";
import { GoBackButton } from "../../../component/common/GoBackButton";
import { Page } from "../../../component/common/Page";
import { FileWithMetadataPreviewWrapper } from "../../../component/layout/FileWithMetadataPreviewWrapper";
import { useRequiredParams } from "../../../hooks/useRequiredParams";
import { getConstructionSiteTitle } from "../ConstructionSitePage";
import { ProjectReceptionContent } from "./ProjectReceptionContent";

export const ProjectReception = () => {
	const { constructionSiteId } = useRequiredParams<{
		constructionSiteId: string;
	}>();

	return (
		<Page>
			<FileWithMetadataPreviewWrapper>
				<div>
					<GoBackButton />
					<H1>
						Réception {getConstructionSiteTitle(Number(constructionSiteId))}
					</H1>
				</div>
				<ProjectReceptionContent />
			</FileWithMetadataPreviewWrapper>
		</Page>
	);
};

export default ProjectReception;
